<t4-header icon="glyphicon-stats"></t4-header>
<t4-report reportId="7D8F6C1B-4E2A-4F8C-9A71-2E6B5C3D9F40"></t4-report>

<t4-container title="{{ 'Turbo.Common.UsedPartsPerTrailerReport.Title' | translate : 'Used Parts Per Trailer' }}" [isLoading]="isLoading">
  <t4-periodPicker [(from)]="fromDate" [(to)]="toDate" (periodChanged)="loadData()"></t4-periodPicker>
  <t4-data-table [rawData]="reportRows" [autoGenerateColumns]="false" matSort [filterFields]="['Trailer','Location','ItemId','Description']">
    <ng-container matColumnDef="CreatedAt">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 120px;">Date</mat-header-cell>
      <mat-cell *matCellDef="let row" style="min-width: 120px;">{{ row.CreatedAt | date : 'yyyy-MM-dd' }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="Trailer">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 130px;">Trailer</mat-header-cell>
      <mat-cell *matCellDef="let row" style="min-width: 130px;"><t4-object-link objectId="{{row.TrailerId}}">{{ row.Trailer }}</t4-object-link></mat-cell>
    </ng-container>

    <ng-container matColumnDef="Location">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 150px;">Location</mat-header-cell>
      <mat-cell *matCellDef="let row" style="min-width: 150px;">{{ row.Location }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="ItemId">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 120px;">Item</mat-header-cell>
      <mat-cell *matCellDef="let row" style="min-width: 120px;">{{ row.ItemId }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="Description">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 240px;">Description</mat-header-cell>
      <mat-cell *matCellDef="let row" style="min-width: 240px;">{{ row.Description }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="Amount">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 90px;">Amount</mat-header-cell>
      <mat-cell *matCellDef="let row" style="min-width: 90px;">{{ row.Amount }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="Price">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 110px;">Price</mat-header-cell>
      <mat-cell *matCellDef="let row" style="min-width: 110px;">{{ row.Price | currency }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="TotalPrice">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 120px;">Total</mat-header-cell>
      <mat-cell *matCellDef="let row" style="min-width: 120px;">{{ row.TotalPrice | currency }}</mat-cell>
    </ng-container>
  </t4-data-table>
</t4-container>
